import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap5';
import Welcome from './Slides/Welcome';
import Thankyou from './Slides/Thankyou';
import Feedback from './Slides/Feedback';

import Actions from './Actions';

export default function Index() {
  const [collection, setCollection] = useState(null);
  const [currentPosition, setCurrentPosition] = useState(0);

  const [show, setShow] = useState(true);

  const closeForm = () => setShow(false);

  const nextSlide = () => {
    setCurrentPosition(currentPosition + 1);
  };

  useEffect(() => {
    Actions.prepareSteps((steps) => {
      setCollection(steps);
    });
  }, []);

  const paddingSize = () => {
    let height = 0;

    document.querySelectorAll('.slide-modal .slide').forEach((el, index) => {
      if (index < currentPosition) {
        height += el.offsetHeight;
      }
    });

    return height;
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={closeForm}
      backdrop="static"
      keyboard={false}
      className="full-size"
    >
      <div className="slide-modal">
        {!collection && (
          <div className="slide center">
            <p>
              Please, wait...
            </p>
          </div>
        )}

        {collection && (
          <div
            className="slide-wrapper"
            style={{ marginTop: `${-1 * paddingSize()}px` }}
          >
            {collection.map((step) => (
              <div
                className={`slide 
                ${step.type === 'welcome' || step.type === 'thank_you' ? 'center' : 'center'} `}
                key={step.position}
              >
                {step.type === 'welcome' && (
                <Welcome
                  nextSlide={nextSlide}
                  closeForm={closeForm}
                />
                )}
                {step.type === 'feedback' && (
                <Feedback
                  step={step}
                  nextSlide={nextSlide}
                />
                )}
                {step.type === 'thank_you' && <Thankyou closeForm={closeForm} />}
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
}
